import Vue from 'vue'
import Router from 'vue-router'
import VueWechatTitle from 'vue-wechat-title'
import CurrentUser from 'lib/CurrentUser'
import * as Util from 'lib/Util'
import AppConfig from 'src/config'

// 【路由懒加载】
// tab页 包含 home 和my两个页面.所以这里的引用可以注释掉
const Index           = resolve => require(['components/Index'], resolve);
const Home            = resolve => require(['components/Home'], resolve);
const EventDetails    = resolve => require(['components/EventDetails'], resolve);
const Userask         = resolve => require(['components/Userask'], resolve);
const QuestDetails    = resolve => require(['components/QuestDetails'], resolve);
const My              = resolve => require(['components/My'], resolve);

// 个人中心页面
const IncomeDetails   = resolve => require(['components/Mycenter/IncomeDetails'], resolve);  // 我的收益明细
const PercentDetails  = resolve => require(['components/Mycenter/PercentDetails'], resolve);  // 我的提成明细
const MyAsks          = resolve => require(['components/Mycenter/MyAsks'], resolve);  // 我的提问
const MyListens       = resolve => require(['components/Mycenter/MyListens'], resolve);  // 我的收听
const Helps           = resolve => require(['components/Mycenter/Helps'], resolve);  // 帮助中心
const ChangePhone     = resolve => require(['components/Mycenter/ChangePhone'], resolve);  // 更换手机号
const BindPhone       = resolve => require(['components/Mycenter/BindPhone'], resolve);  // 绑定手机号
const FirstBindPhone  = resolve => require(['components/Mycenter/FirstBindPhone'], resolve);  // 绑定手机号
const SecondBindPhone = resolve => require(['components/Mycenter/SecondBindPhone'], resolve);  // 绑定手机号
// 公共页面
const Empty           = resolve => require(['components/common/EmptyList'], resolve);  // 空页面

Vue.use(VueWechatTitle)
Vue.use(Router)

const router = new Router({
  mode:"history",
  base: "/member",
  routes: [
    { path: '/', redirect: '/home' },
    { path: '/home', name: 'home', component: Home, meta: { title: '名医问答', tabBar:true, home:true } },
    { path: '/event', name: 'eventdetails', component: EventDetails, meta: { title: '活动详情' } },
    { path: '/userask', name: 'userask', component: Userask, meta: { title: '立即提问' } },
    { path: '/question', name: 'questdetails', component: QuestDetails, meta: { title: '问题详情' } },
    { path: '/my', name: 'my', component: My, meta: { title: '名医问答', tabBar:true, my:true }},
    // 个人中心页面[前面试试路径，后面是命名路由]
    { path: '/my/income', name: 'income', component: IncomeDetails, meta: { title: '收益明细' } },
    { path: '/my/percent', name: 'percent', component: PercentDetails, meta: { title: '提成明细' } },
    { path: '/my/myasks', name: 'myasks', component: MyAsks, meta: { title: '我的提问' } },
    { path: '/my/mylistens', name: 'mylistens', component: MyListens, meta: { title: '我的收听' } },
    { path: '/my/helps', name: 'helps', component: Helps, meta: { title: '帮助中心' } },
    { path: '/my/changephone', name: 'changephone', component: ChangePhone, meta: { title: '更换手机' } },
    { path: '/my/bindphone', name: 'bindphone', component: BindPhone, meta: { title: '绑定手机' } },
    { path: '/my/firstbindphone', name: 'firstbindphone', component: FirstBindPhone, meta: { title: '绑定手机号' } },
    { path: '/my/secondbindphone', name: 'secondbindphone', component: SecondBindPhone, meta: { title: '更换手机号' } },

    // 空页面
    { path: '*', name: 'empty', component: Empty, meta: { title: '404' } },
  ]

});

if (!DEBUG) {  // 非debug环境下进行判断
    // 路由开始之前，进行判断操作
    router.beforeEach(function (to, from, next) {
      let uid = Util.getCookie('userid'),
        promise;  // 获取用户ID，并声明一个承诺
      if (!uid) {  // 没有用户信息，则需要进行登录操作
        promise = Promise.reject("need Login");
      } else {  // 有用户ID，则获取当前用户信息
        promise = CurrentUser();
      }

      promise.then(res => {
        if (res) {  // 获取信息成功，跳转到下一个页面
          return next()
        }
        return Promise.reject(res);
      }).catch(e => {  // 获取用户信息失败，则跳转重新授权
        window.location.href = AppConfig.Auth.Login.replace(/\{url\}/g, encodeURIComponent(window.location.origin + router.history.base + to.fullPath));
      })
    });
}


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js